import * as React from 'react'

export enum CircleProgressSizes {
  SMALL = '30px',
  MEDIUM = '44px',
}

interface Props {
  progress: number
  className?: string
  size?: CircleProgressSizes
  children?: React.ReactElement
}

export const CircleProgress = ({
  progress,
  className,
  size = CircleProgressSizes.MEDIUM,
  children,
}: Props): JSX.Element => {
  const strokeDashoffset = 600 - (600 * progress) / 100
  return (
    <div className={className} style={{ width: size, height: size, minHeight: size, minWidth: size }}>
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="93" fill="transparent" stroke="#e44b5d" strokeLinecap="round" strokeWidth="14" />
        <circle
          cx="100"
          cy="100"
          r="93"
          fill="transparent"
          stroke="#fefdfd"
          strokeLinecap="round"
          strokeWidth="14"
          strokeDasharray="600"
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 100 100)"
        />
      </svg>
      {children}
    </div>
  )
}
